import { propKeyColumnDictonary } from 'constants/tableColumns';

/**
 * This function converts a data property into a lowercase
 * text Separated by an underscore.
 *
 * @param {String} str Column header prop
 * @returns {String} Column header text seperated by _
 */
export const getHeaderTextByProp = (str) => {
    let tableColumnName = propKeyColumnDictonary[str];

    if (!tableColumnName) {
        tableColumnName = str
            .replace(/[A-Z]/g, (match) => '_' + match.toLowerCase())
            .replace(/^_/, '');
    }

    return tableColumnName;
};

export const removeCurrencyFormatter = (currency) => {
    const value = currency.replace(/,/g, '');
    return parseFloat(value);
};
